// extracted by mini-css-extract-plugin
export default {"OptionChip":"DiscoveryMobileFilterOption_OptionChip__WqGZD","OptionChipSelected":"DiscoveryMobileFilterOption_OptionChipSelected__4Vcmz"};